import { beRecipientGetDynamicFieldsDefinition } from "Api/beRecipientApi";

import { beRecipientApiGetLoginConfidentialDefinitions } from "Api/beRecipientApiTS";

import {
  STORE_KEY_LOGIN_TYPE,
  STORE_KEY_USER,
  storeGet,
} from "mailup-react-helpers";

import { LOGIN_TYPE_ADMLIMITED } from "Constants";

import type { ColumnName, DynamicField } from "Pages/RecipientsList/model";

export const fetchDynamicFields = async (): Promise<
  [DynamicField[], string[]]
> => {
  const idLogin = storeGet(STORE_KEY_USER).Id as number;

  const loginType = storeGet(STORE_KEY_LOGIN_TYPE);

  const [items, confidentials] = await Promise.all([
    beRecipientGetDynamicFieldsDefinition(),
    beRecipientApiGetLoginConfidentialDefinitions(idLogin),
  ]);

  if (!items) {
    throw new Error("beRecipientGetDynamicFieldsDefinition returned no items");
  }

  const tmp = confidentials
    .filter((f) => f.DataCode.startsWith("Field"))
    .map((f) => Number.parseInt(f.DataCode.substring(5), 10));

  return [
    items.map(
      ({
        Id: id,
        Description: description,
      }: {
        Id: number;
        Description: string;
      }) => ({
        id,
        description,
        masked: loginType === LOGIN_TYPE_ADMLIMITED || tmp.includes(id),
      }),
    ),
    confidentials.map((o) => o.DataCode),
  ];
};

const sortableFields: string[] = [
  "Id",
  "Email",
  "Mobile",
  "RegistrationDate",
  "EmailPendingDate",
  "EmailSubscriptionDate",
  "EmailUnsubscriptionDate",
  "SMSSubscriptionDate",
  "SMSUnsubscriptionDate",
  "TrackingState",
  "TrackingLastChange",
];
export const isSortableField = (s: string): boolean => {
  return sortableFields.includes(s) || s.startsWith("Field");
};

export const reorder = <T>(prev: T[], from: number, to: number): T[] => {
  if (from === to) {
    return prev;
  }
  const toBeMoved = prev[from];
  const before = prev.slice(0, from);
  const after = prev.slice(from + 1);

  const newArr =
    to < from
      ? [...before.slice(0, to), toBeMoved, ...before.slice(to), ...after]
      : [
          ...before,
          ...after.slice(0, to - from),
          toBeMoved,
          ...after.slice(to - from),
        ];

  return newArr;
};

export const getExistingColumns = (
  columns: ColumnName[],
  df: DynamicField[],
): ColumnName[] => {
  const dfIds = df.map((o) => o.id);

  const re = /^Field(\d+)$/;

  return columns.filter((c) => {
    const m = c.match(re);

    if (m !== null && !dfIds.includes(Number.parseInt(m[1], 10))) {
      return false;
    }

    return true;
  });
};
